import { useForm } from 'react-hook-form';
import type { BaseAsset, Language, Theme } from '@/shared/types';
import type { DisplaySettingsFormValues } from './types';
import {
  DEFAULT_BASE_ASSET,
  DEFAULT_DATE_FORMAT,
  FALLBACK_LANGUAGE,
} from '@/shared/config';
import { getCurrentTimezoneOffset } from '@/shared/utils';

type Props = {
  language: Language;
  theme: Theme | null;
  baseAsset: BaseAsset;
};

const useDisplaySettingsForm = ({ language, theme, baseAsset }: Props) => {
  const defaultValues: DisplaySettingsFormValues = {
    lang: language || FALLBACK_LANGUAGE,
    asset: baseAsset || DEFAULT_BASE_ASSET,
    theme: theme || 'light',
    dateFormat: DEFAULT_DATE_FORMAT,
    timeZone: getCurrentTimezoneOffset(),
  };

  const form = useForm<DisplaySettingsFormValues>({
    mode: 'onChange',
    defaultValues,
  });

  return {
    form,
  };
};

export { useDisplaySettingsForm };
